import api from '@/js/services/api';
export default {
    addToBannedList(client_id, applicant_id) {
        return api().post(`/master-admin/sites-clients/${client_id}/banned-employer/add`, {applicant_id})
    },
    addNewComment(client_id, comment) {
        return api().post(`/master-admin/sites-clients/${client_id}/comment/create`, {comment});
    },
    deleteComment(comment_id) {
        return api().delete(`/master-admin/sites-clients/comment/${comment_id}/delete`);
    },

    updateComment(comment_id, comment) {
        return api().put(`/master-admin/sites-clients/comment/${comment_id}/update`, {comment})
    },

    addNewPosition(id, position_id) {
        return api().post(`/master-admin/sites-clients/` + id + `/position/add`, {position_id})
    },
    deleteClient(id) {
        return api().delete(`/master-admin/sites-clients/` + id + `/delete`);
    },
    deletePosition(client_id, position_id) {
        return api().post(`/master-admin/sites-clients/${client_id}/position/delete`, {position_id});
    },
    deleteEmployee(employee_id) {
        return api().delete(`/master-admin/sites-clients/${employee_id}/banned-employer/delete`);
    },
    getClientsList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/sites-clients/get?' + searchParams.toString())
    },

    getClientInfo(id) {
        return api().get(`/master-admin/sites-clients/` + id + `/get`);
    },

    saveNewSite(form) {
        return api().post(`/master-admin/sites-clients/store`, form);
    },
    updateClientInfo(id,form) {
        return api().put(`/master-admin/sites-clients/${id}/update`, form);
    },

    updateStatus(client_id) {
        return api().put(`/master-admin/sites-clients/${client_id}/status/update`)
    }

}
